import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { useDispatch as useReduxDispatch, useSelector as useReduxSelector } from 'react-redux';

import ui from './ui/reducer';
import appReducer from './app/reducer';
import runReducer from './run/reducer';
import userReducer from './user/reducer';
import jobsReducer from './jobs/jobs-slice';
import folderReducer from './folder/reducer';
import contentReducer from './content/reducer';
import workspaceReducer from './workspace/reducer';
import h5pEditorReducer from './h5p-editor/reducer';
import lumiEditorReducer from './lumi-editor/reducer';
import messagesReducer from './messages/messages-slice';
import subscriptionReducer from './subscription/reducer';
import websocketReducer from './websocket/websocket-slice';
import { workspaceMiddleware } from './workspace/middleware';
import objectivesReducer from './objectives/objectives-slice';
import contentBrowserReducer from './content-browser/reducer';
import worksheetChatReducer from './worksheet-chat/worksheet-chat-slice';
import simulationChatReducer from './simulation-chat/simulation-chat-slice';
// ----------------------------------------------------------------------

const rootReducer = combineReducers({
  app: appReducer,
  lumiEditor: lumiEditorReducer,
  user: userReducer,
  run: runReducer,
  subscription: subscriptionReducer,
  workspace: workspaceReducer,
  folder: folderReducer,
  content: contentReducer,
  contentBrowser: contentBrowserReducer,
  worksheetChat: worksheetChatReducer,
  simulationChat: simulationChatReducer,
  h5pEditor: h5pEditorReducer,
  websocket: websocketReducer,
  objectives: objectivesReducer,
  jobs: jobsReducer,
  messages: messagesReducer,
  ui,
});

const store = configureStore({
  reducer: rootReducer, // persistReducer(rootPersistConfig, rootReducer)
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(workspaceMiddleware),
});

// const persistor = persistStore(store);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

const { dispatch } = store;

export function setupStore(preloadedState?: any) {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(workspaceMiddleware),
    preloadedState,
  });
}

export type AppStore = ReturnType<typeof setupStore>;

const useSelector = useReduxSelector;
const useDispatch = () => useReduxDispatch<AppDispatch>();

export { store, dispatch, useSelector, useDispatch };
